export const EXTERNAL_CHANGES_SOURCE = {
  GMB: 1,
  EXTERNAL: 2
};

export const EXTERNAL_CHANGES_TYPE = {
  ADDITION: 1,
  REMOVAL: 2,
  CHANGE: 3
};

export const EXTERNAL_CHANGES_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3,
  DELETED_DUE_TO_GMB: 4,
  DELETED_DUE_TO_CENTER: 5,
  SUPERSEDED: 6
};

export const EXTERNAL_CHANGES_HISTORY_STATUSES = [
  EXTERNAL_CHANGES_STATUS.ACCEPTED,
  EXTERNAL_CHANGES_STATUS.REJECTED,
  EXTERNAL_CHANGES_STATUS.SUPERSEDED
];

export const EXTERNAL_CHANGES_FIELD = {
  NAME: "name",
  STREET: "street",
  POSTAL_CODE: "postal_code",
  CITY: "city",
  COUNTRY: "country",
  STORE_CODE: "store_code",
  PRIMARY_CATEGORY: "primary_category",
  ADDITIONAL_CATEGORIES: "additional_categories",
  WEBSITE: "website",
  PRIMARY_PHONE: "phone_number",
  ADDITIONAL_PHONES: "phone_number_2",
  REGULAR_HOURS: "opening_hours",
  SPECIAL_HOURS: "special_hours",
  ATTRIBUTES: "attributes",
  SERVICES: "service_items",
  DESCRIPTION: "description",
  OPENING_DATE: "opening_date",
  LOCATION_STATE: "location_state",
  OPEN_STATUS: "open_status",
  LABELS: "labels",
  MORE_HOURS: "more_hours"
};

export const EXTERNAL_CHANGES_PROTECT_SOURCE = {
  GMB: "gmb",
  EXTERNAL: "external"
};

export const EXTERNAL_CHANGES_PROTECT_STATUS = {
  IDLE: 1,
  ACCEPT: 2,
  REJECT: 3
};
